import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { CommonResponseList } from 'src/model/common';

import AIService from 'src/services/api/aiLabeling';

const QUERY_GET_SINGLE_PREDICTION = 'QUERY_GET_SINGLE_PREDICTION';
const QUERY_GET_SENTENCE_PREDICTION = 'QUERY_GET_SENTENCE_PREDICTION';
const QUERY_GET_HS_CODE_DETAIL = 'QUERY_GET_HS_CODE_DETAIL';
const QUERY_GET_BULK_UPLOAD_RESULT = 'QUERY_GET_BULK_UPLOAD_RESULT';
const QUERY_GET_BULK_UPLOAD_RESULT_HISTORY = 'QUERY_GET_BULK_UPLOAD_RESULT_HISTORY';

export const useQueryGetSinglePrediction = (params: Record<string, string>) => {
  const { data, isFetching } = useQuery({
    queryKey: [QUERY_GET_SINGLE_PREDICTION, params],
    queryFn: () => AIService.getSinglePrediction(params),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    placeholderData: keepPreviousData,
    enabled: !!params?.sentence,
  });
  return {
    data,
    isFetching,
  };
};

export const useQueryGetSentencePrediction = (params: Record<string, string>) => {
  const { data, isFetching } = useQuery({
    queryKey: [QUERY_GET_SENTENCE_PREDICTION, params],
    queryFn: () => AIService.getHsCodePredictionWithText(params),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    placeholderData: keepPreviousData,
    enabled: !!params?.text,
  });
  return {
    data,
    isFetching,
  };
};

export const useQueryGetHSCodeDetailAIService = (params: { code: string }) => {
  const { data, isFetching } = useQuery({
    queryKey: [QUERY_GET_HS_CODE_DETAIL, params],
    queryFn: () => AIService.getHSCodeDetail(params),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    placeholderData: keepPreviousData,
    enabled: !!params.code,
  });
  return {
    data,
    isFetching,
  };
};
export const useQueryBulkUploadResult = (params: Record<string, any>) => {
  const { data, isFetching } = useQuery({
    queryKey: [QUERY_GET_BULK_UPLOAD_RESULT, params],
    queryFn: () => AIService.getBulkUploadResult(params),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    placeholderData: keepPreviousData,
    initialData: new CommonResponseList(),
    enabled: !!params.id,
  });
  return {
    data,
    isFetching,
  };
};

export const useQueryGetHistoryBulkUpload = (params: Record<string, any>) => {
  const { data, isFetching } = useQuery({
    queryKey: [QUERY_GET_BULK_UPLOAD_RESULT_HISTORY, params],
    queryFn: () => AIService.getHistoryBulkUpload(params),
    initialData: new CommonResponseList(),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    placeholderData: keepPreviousData,
    enabled: !!params.user_uuid,
  });
  return {
    data,
    isFetching,
  };
};
